import { render, staticRenderFns } from "./GDNRegionBox.vue?vue&type=template&id=e05f4824&"
import script from "./GDNRegionBox.vue?vue&type=script&lang=js&"
export * from "./GDNRegionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports